<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="100px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="栏目" prop="group_id">
        <el-select v-model="formData.group_id" placeholder="请选择栏目" filterable @change="getCategoryList">
          <el-option label="请选择栏目" value=""></el-option>
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲员" prop="speaker_id">
        <el-select v-model="formData.speaker_id" placeholder="请选择讲员" filterable @change="getCategoryList">
          <el-option label="请选择讲员" value=""></el-option>
          <el-option v-for="item in speakerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专辑" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="请选择专辑名称" filterable>
          <el-option label="请选择专辑" value=""></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="content_type">
        <el-select v-model="formData.content_type" placeholder="请选择内容类型" filterable>
          <el-option label="请选择类型" value=""></el-option>
          <el-option label="视频" :value="3"></el-option>
          <el-option label="音频" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="音频/视频" prop="media_url">
        <el-upload
          name="media"
          action="/proxy/admin/upload_media"
          :before-upload="handleUpload"
          :on-success="handleSuccess"
          :file-list="mediaFileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-progress v-if="uploading" :percentage="upPercent"></el-progress>
        <el-input v-model="formData.media_url"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
export default {
  name: 'content_add',
  props: [
    'visible', 'id', 'groupList', 'speakerList'
  ],
  data () {
    return {
      mediaFileList: [],
      title: '添加音视频',
      categoryList: [],
      confirmDisable: false,
      formData: {
        title: '',
        group_id: '',
        speaker_id: '',
        category_id: '',
        content_type: '',
        media_url: ''
      },
      picUrl: '',
      uploading: 0,
      upPercent: 0,
      uploadPrepareResp: {},
      formRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        group_id: [
          { required: true, message: '栏目不能为空', trigger: 'blur' }
        ],
        speaker_id: [
          { required: true, message: '讲员不能为空', trigger: 'blur' }
        ],
        category_id: [
          { required: true, message: '专辑不能为空', trigger: 'blur' }
        ],
        content_type: [
          { required: true, message: '内容类型不能为空', trigger: 'blur' }
        ],
        media_url: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.mediaFileList = []
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑音视频'
        this.getInfo(this.id)
      }
      this.confirmDisable = false
      this.uplodPrepare()
    },
    async getCategoryList () {
      if (this.formData.group_id === 0 || this.formData.speaker_id === 0) {
        this.categoryList = []
        this.formData.category_id = 0
        return
      }
      const res = await this.$http.get('/admin/category/select_list', {
        group_id: this.formData.group_id,
        speaker_id: this.formData.speaker_id
      })
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/content/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          group_id: res.data.group_id,
          speaker_id: res.data.speaker_id,
          category_id: res.data.category_id,
          content_type: res.data.content_type,
          media_url: res.data.media_url
        }
        this.getCategoryList()
        // this.mediaFileList = [{ name: res.data.media_url, url: res.data.media_url_full }]
        this.mediaFileList = []
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'media/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.media_url = res.key
      }
      observable.subscribe({ next, error, complete })
      this.uplodPrepare()
      return false
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        // this.mediaFileList = [{ name: resp.data.path, url: resp.data.url }]
        this.mediaFileList = []
        this.formData.media_url = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
